(function () {
  'use strict';
  if (window.RustyMigrationAdapter) return;

  var node = document.querySelector('[data-rm-site-contract]');
  var contract = { catalog: { lines: [], categories: [] }, commerce: {}, merchandising: {}, design: { tokens: {}, motions: {}, components: {}, primitives: {}, assets: {}, behaviors: {} } };
  try {
    contract = JSON.parse((node && node.textContent) || '{}') || contract;
  } catch (error) {
    contract.error = 'invalid_contract';
  }
  contract.catalog = contract.catalog || { lines: [], categories: [] };
  contract.commerce = contract.commerce || {};
  contract.merchandising = contract.merchandising || {};
  contract.design = contract.design || { tokens: {}, motions: {}, components: {}, primitives: {}, assets: {}, behaviors: {} };
  if (!Array.isArray(contract.catalog.lines)) contract.catalog.lines = [];

  function comparable(value) {
    return value == null ? null : String(value).trim().toLowerCase();
  }

  function matches(line, filters) {
    return Object.keys(filters || {}).every(function (key) {
      var expected = filters[key];
      if (expected === undefined) return true;
      if (Array.isArray(expected)) return expected.some(function (candidate) { return comparable(line[key]) === comparable(candidate); });
      return comparable(line[key]) === comparable(expected);
    });
  }

  function list(filters) {
    return contract.catalog.lines.filter(function (line) { return matches(line, filters || {}); });
  }

  function resolve(intent) {
    var candidates = list(intent || {});
    return { match: candidates.length === 1 ? candidates[0] : null, candidates: candidates, count: candidates.length };
  }

  function cartItem(intent, quantity, properties) {
    var result = resolve(intent);
    if (!result.match) throw new Error('Migration intent resolved to ' + result.count + ' Shopify variants.');
    return { id: result.match.variantId, quantity: Math.max(1, Number(quantity) || 1), properties: properties || {} };
  }

  function applyDesignTokens(target) {
    var root = target || document.documentElement;
    Object.keys(contract.design.tokens || {}).forEach(function (name) {
      root.style.setProperty(name, contract.design.tokens[name]);
    });
  }

  function mountMotions(scope) {
    var root = scope || document;
    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-rm-reveal]'));
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (element) { element.dataset.rmRevealed = 'true'; });
      return;
    }
    var reveal = (contract.design.motions || {}).reveal || {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.dataset.rmRevealed = 'true';
        observer.unobserve(entry.target);
      });
    }, { threshold: Number(reveal.threshold || 0.12) });
    nodes.forEach(function (element) {
      if (element.dataset.rmMotionBound === 'true') return;
      element.dataset.rmMotionBound = 'true';
      observer.observe(element);
    });
  }

  function mountChrome() {
    var header = document.getElementById('site-header');
    if (!header || header.dataset.rmChromeBound === 'true') return;
    header.dataset.rmChromeBound = 'true';
    var behavior = (contract.design.behaviors || {}).headerCompact || {};
    var enterAt = Number(behavior.enterPx || 72);
    var exitAt = Number(behavior.exitPx || 12);
    var offsetVariable = behavior.offsetVariable || '--rm-header-offset';
    var compact = false;
    var ticking = false;
    var offsetFrame = 0;
    var setHeaderOffset = function () {
      var height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty(offsetVariable, height + 'px');
    };
    var pulseHeaderOffset = function () {
      var started = performance.now();
      if (offsetFrame) cancelAnimationFrame(offsetFrame);
      var tick = function (now) {
        setHeaderOffset();
        if (now - started < 340) offsetFrame = requestAnimationFrame(tick);
        else offsetFrame = 0;
      };
      offsetFrame = requestAnimationFrame(tick);
    };
    var syncCompact = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      var previous = compact;
      if (!compact && y > enterAt) compact = true;
      else if (compact && y < exitAt) compact = false;
      header.dataset.compact = compact ? 'true' : 'false';
      setHeaderOffset();
      if (previous !== compact) pulseHeaderOffset();
      ticking = false;
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(syncCompact);
    };
    setHeaderOffset();
    syncCompact();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderOffset, { passive: true });
    if (typeof ResizeObserver === 'function') new ResizeObserver(setHeaderOffset).observe(header);
  }

  function promotionMessage(offer, now) {
    if (!offer) return '';
    var parts = [offer.title || ''];
    var rule = offer.endDateRule || {};
    if (rule.type === 'rolling-days') {
      var endDate = new Date(now || Date.now());
      endDate.setDate(endDate.getDate() + Number(rule.days || 0));
      parts.push('Ends: ' + endDate.toLocaleDateString('en-US'));
    }
    if (offer.suffix) parts.push(offer.suffix);
    return parts.filter(Boolean).join(' | ');
  }

  function mountPromotions(scope) {
    var root = scope || document;
    var config = contract.commerce.promotions || {};
    var offers = Array.isArray(config.offers) ? config.offers : [];
    Array.prototype.slice.call(root.querySelectorAll('[data-rm-announcement]')).forEach(function (announcement) {
      var message = announcement.querySelector('[data-rm-promotion-message]');
      if (!message || !offers.length) return;
      message.textContent = promotionMessage(offers[0], Date.now());
      announcement.setAttribute('data-rm-promotion-source', config.source || 'adapter');
      announcement.setAttribute('data-rm-promotion-id', offers[0].id || 'promotion');
    });
  }

  function mountStickyStates(scope) {
    var root = scope || document;
    var behavior = (contract.design.behaviors || {}).stickyState || {};
    var stuckClass = behavior.stuckClass || 'is-stuck';
    var offsetVariable = behavior.offsetVariable || '--rm-header-offset';
    Array.prototype.slice.call(root.querySelectorAll('[data-rm-sticky]')).forEach(function (target) {
      if (target.dataset.rmStickyBound === 'true' || typeof IntersectionObserver !== 'function') return;
      var sentinelId = target.getAttribute('data-rm-sticky-sentinel-id');
      var sentinel = sentinelId ? document.getElementById(sentinelId) : target.previousElementSibling;
      if (!sentinel || !sentinel.matches('[data-rm-sticky-sentinel]')) return;
      target.dataset.rmStickyBound = 'true';
      var observer = null;
      var headerOffset = function () {
        var parsed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(offsetVariable));
        if (Number.isFinite(parsed)) return parsed;
        var header = document.getElementById('site-header');
        return header ? Math.ceil(header.getBoundingClientRect().height) || 80 : 80;
      };
      var bind = function () {
        if (observer) observer.disconnect();
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { target.classList.toggle(stuckClass, !entry.isIntersecting); });
        }, { threshold: 0, rootMargin: '-' + headerOffset() + 'px 0px 0px 0px' });
        observer.observe(sentinel);
      };
      bind();
      var header = document.getElementById('site-header');
      if (header && typeof ResizeObserver === 'function') new ResizeObserver(bind).observe(header);
    });
  }

  function setMappedAsset(element, key) {
    if (!element) return false;
    var map = {};
    try { map = JSON.parse(element.getAttribute('data-rm-asset-map') || '{}') || {}; }
    catch (error) { map = {}; }
    var source = map[String(key)] || '';
    element.hidden = !source;
    if (!source) return false;
    if ('src' in element) element.src = source;
    element.setAttribute('data-rm-asset-key', String(key));
    return true;
  }

  /* Canonical Astro symbol UI assets from site/src/data/shop-products.ts. */
  var symbolMediaRoot = 'https://admin.mackandlee.com/m/rustymarquee/images/2026/07/';
  var symbolProductRoot = 'https://cdn.shopify.com/s/files/1/0706/6071/products/';
  var symbolAssets = {
    heart: { icon: symbolMediaRoot + 'afb858df7f6c70aa.avif', preview: symbolMediaRoot + 'f953ba76bb3df913.avif' },
    star: { icon: symbolMediaRoot + '2622eeb59e1e39ca.avif', preview: symbolMediaRoot + 'a4e86a8734cb50db.avif' },
    arrow: { icon: symbolMediaRoot + 'f162677c94b6ee3c.avif', preview: symbolMediaRoot + 'b929b4ba5896e233.avif' },
    peace: { icon: symbolMediaRoot + 'bf00778fd2500e7a.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-peace-sign-vintage-marquee-sign-with-lights-rustic-1_b4e6307e-5182-476c-8562-7bdd60f4056f.jpg?v=1545256744' },
    ampersand: { icon: symbolMediaRoot + 'd59f7a85152de323.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-ampersand-vintage-marquee-lights-sign-rustic-1_0296c396-0c66-4abd-a025-4aa5d6d906e1.jpg?v=1545257114' },
    hashtag: { icon: symbolMediaRoot + '9846487228801b38.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-hashtag-vintage-marquee-lights-sign-rustic-1_fa1d67bc-6551-4c3c-bd96-51c3d681269c.jpg?v=1545257109' },
    at: { icon: symbolMediaRoot + '98f94630c95acfda.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-vintage-marquee-lights-sign-rustic-1.jpg?v=1530469915' },
    moon: { icon: symbolMediaRoot + 'b130a5f9d97de61e.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-crescent-moon-vintage-marquee-lights-sign-rustic-1.jpg?v=1530470302' },
    texas: { icon: symbolMediaRoot + 'c003fc9d890a1b11.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-texas-vintage-marquee-lights-sign-rustic-1.jpg?v=1545257105' },
    longhorn: { icon: symbolMediaRoot + '0de7c788b9b7ce73.avif', preview: symbolProductRoot + 'marquee-symbol-lights-texas-longhorns-vintage-marquee-lights-sign-rustic-1.jpg?v=1530468789' },
    guitar: { icon: symbolMediaRoot + '816b1e6423bad95c.avif', preview: symbolProductRoot + 'marquee-symbol-lights-36-large-guitar-vintage-marquee-sign-with-lights-rustic-1.jpg?v=1545257138' },
    mustache: { icon: symbolMediaRoot + 'ce05cc0390e4355b.avif', preview: symbolProductRoot + 'marquee-symbol-lights-mustache-vintage-marquee-lights-sign-rustic-1.jpg?v=1545256752' },
    cloud: { icon: symbolMediaRoot + 'a93c7ca4650dd48d.avif', preview: symbolProductRoot + 'marquee-symbol-lights-cloud-vintage-marquee-lights-sign-white-finish-1.jpeg?v=1530470909' },
    anchor: { icon: symbolMediaRoot + 'a78ae00ce5ca12fc.avif', preview: symbolProductRoot + 'marquee-symbol-lights-anchor-vintage-marquee-sign-with-lights-rustic-1_e8b18bff-d820-4dc4-9c55-df9d3f32b70a.jpg?v=1545256747' },
    martini: { icon: symbolMediaRoot + '736648bcc9d64a45.avif', preview: symbolProductRoot + 'marquee-symbol-lights-martini-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530470780' },
    horseshoe: { icon: symbolMediaRoot + 'efd15d581d87d171.avif', preview: symbolProductRoot + 'marquee-symbol-lights-horseshoe-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530470784' },
    lips: { icon: symbolMediaRoot + '818f81b7e1898a6b.avif', preview: symbolProductRoot + 'marquee-symbol-lights-kissing-lips-vintage-marquee-lights-sign-rustic-1.jpg?v=1530468770' },
    butterfly: { icon: symbolMediaRoot + '8af72b0a76753175.avif', preview: symbolProductRoot + 'marquee-symbol-lights-butterfly-vintage-marquee-sign-with-lights-rustic-1.jpeg?v=1530470799' },
    dragonfly: { icon: symbolMediaRoot + '391dc6d9d021b35f.avif', preview: symbolProductRoot + 'marquee-symbol-lights-dragonfly-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530470789' },
    flamingo: { icon: symbolMediaRoot + '5f01dba4cbe36d49.avif', preview: symbolProductRoot + 'marquee-symbol-lights-flamingo-vintage-marquee-lights-sign-pink-finish-1_47374570-6bf3-4448-b716-8ab2f26adfa8.jpeg?v=1530470803' },
    chili: { icon: symbolMediaRoot + 'fa75f156232158b5.avif', preview: symbolProductRoot + 'marquee-symbol-lights-chili-pepper-vintage-marquee-lights-sign-rustic-1.jpg?v=1530470886' },
    pumpkin: { icon: symbolMediaRoot + '91227b5a02930d3e.avif', preview: symbolProductRoot + 'marquee-symbol-lights-pumpkin-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530470921' },
    shamrock: { icon: symbolMediaRoot + '45331aff5d41ecdb.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-irish-shamrock-vintage-marquee-lights-sign-rustic-1_1ae59cb5-a803-4612-8bfa-ffc2b838a788.jpg?v=1545257100' },
    skull: { icon: symbolMediaRoot + '1e190c8a8c34a347.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-skull-crossbones-vintage-marquee-lights-sign-rustic-1.jpg?v=1530469913' },
    fleur: { icon: symbolMediaRoot + '41d37802399df96f.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-fleur-de-lis-vintage-marquee-lights-sign-rustic-1.jpg?v=1530468775' },
    cross: { icon: symbolMediaRoot + 'c3b221ba99737b00.avif', preview: symbolProductRoot + 'marquee-symbol-lights-christian-cross-symbol-marquee-light-sign-1.jpg?v=1530468674' },
    om: { icon: symbolMediaRoot + '1586d589f7e94854.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-yoga-om-vintage-marquee-lights-sign-rustic-1.jpg?v=1530469950' },
    musicnote: { icon: symbolMediaRoot + 'b54848ddb61aeb78.avif', preview: symbolProductRoot + 'marquee-symbol-lights-music-note-vintage-marquee-lights-sign-black-finish-1.jpeg?v=1530470902' },
    treble: { icon: symbolMediaRoot + '63ebdb742b850aee.avif', preview: symbolProductRoot + 'marquee-symbol-lights-music-treble-vintage-marquee-lights-sign-black-finish-1.jpg?v=1530470927' },
    wine: { icon: symbolMediaRoot + 'fe50e83db8ccb663.avif', preview: symbolProductRoot + 'marquee-symbol-lights-wine-vintage-marquee-lights-sign-with-red-lights-rustic-1.jpeg?v=1530470776' },
    california: { icon: symbolMediaRoot + 'fb12418550d34ecc.avif', preview: symbolProductRoot + 'marquee-symbol-lights-california-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530470794' },
    florida: { icon: symbolMediaRoot + '8f5d583d6f6eb996.avif', preview: symbolProductRoot + 'marquee-symbol-lights-24-florida-vintage-marquee-lights-sign-rustic-1.jpeg?v=1530469918' },
    nebraska: { icon: symbolMediaRoot + 'a183767e9ad244b9.avif', preview: symbolProductRoot + 'marquee-symbol-lights-nebraska-vintage-marquee-lights-sign-rustic-1.jpg?v=1530471469' }
  };

  function symbolAsset(key) {
    return symbolAssets[String(key || '').toLowerCase()] || null;
  }

  function easterDate(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  }

  function campaignDate(campaign, year) {
    if (campaign.dateRule === 'easter') return easterDate(year);
    return new Date(year, Number(campaign.month || 1) - 1, Number(campaign.day || 1), 12, 0, 0, 0);
  }

  function activeCampaign(config, now) {
    var today = new Date(now || Date.now());
    today.setHours(12, 0, 0, 0);
    var leadDays = Number(config.seasonalLeadDays || 61);
    var candidates = [];
    (config.campaigns || []).forEach(function (campaign) {
      [today.getFullYear(), today.getFullYear() + 1].forEach(function (year) {
        var date = campaignDate(campaign, year);
        var daysUntil = Math.round((date.getTime() - today.getTime()) / 86400000);
        if (daysUntil >= 0 && daysUntil <= leadDays) candidates.push({ campaign: campaign, date: date, daysUntil: daysUntil });
      });
    });
    candidates.sort(function (left, right) { return left.daysUntil - right.daysUntil; });
    return candidates[0] || null;
  }

  function rankMerchandise(kind, keys, now, itemLimit) {
    var config = contract.merchandising[kind] || {};
    var available = (keys || []).map(String);
    var seasonal = activeCampaign(config, now);
    var priority = [];
    if (seasonal) priority = priority.concat(seasonal.campaign.keys || []);
    priority = priority.concat(config.popularity || [], available);
    var seen = {};
    var ranked = priority.filter(function (key) {
      key = String(key);
      if (seen[key] || available.indexOf(key) === -1) return false;
      seen[key] = true;
      return true;
    });
    return {
      keys: ranked.slice(0, Number(itemLimit || config.maxItems || ranked.length)),
      campaign: seasonal ? { id: seasonal.campaign.id, label: seasonal.campaign.label, daysUntil: seasonal.daysUntil } : null,
    };
  }

  function mountMerchandising(scope) {
    var root = scope || document;
    Array.prototype.slice.call(root.querySelectorAll('[data-rm-merch-list]')).forEach(function (container) {
      var arrange = function () {
        var kind = container.getAttribute('data-rm-merch-list') || '';
        var config = contract.merchandising[kind] || {};
        var items = Array.prototype.slice.call(container.querySelectorAll('[data-rm-merch-key]'));
        var byKey = {};
        items.forEach(function (item) { byKey[item.getAttribute('data-rm-merch-key') || ''] = item; });
        var itemWidth = Number(config.itemWidthPx || 32);
        var gap = Number(config.gapPx || 6);
        var columns = Math.max(1, Math.floor((container.clientWidth + gap) / (itemWidth + gap)));
        var capacity = Math.min(Number(config.maxItems || items.length), columns * Number(config.maxRows || 2));
        var result = rankMerchandise(kind, Object.keys(byKey), Date.now(), capacity);
        var remaining = Object.keys(byKey).filter(function (key) { return result.keys.indexOf(key) === -1; });
        result.keys.concat(remaining).forEach(function (key) { container.appendChild(byKey[key]); });
        items.forEach(function (item) { item.hidden = result.keys.indexOf(item.getAttribute('data-rm-merch-key') || '') === -1; });
        container.setAttribute('data-rm-merch-campaign', result.campaign ? result.campaign.id : 'popular');
        container.setAttribute('data-rm-merch-count', String(result.keys.length));
      };
      arrange();
      if (container.dataset.rmMerchBound !== 'true' && typeof ResizeObserver === 'function') {
        container.dataset.rmMerchBound = 'true';
        new ResizeObserver(arrange).observe(container);
      }
    });
  }

  window.RustyMigrationAdapter = Object.freeze({
    schemaVersion: contract.schemaVersion || null,
    generatedAt: contract.generatedAt || null,
    shop: contract.shop || null,
    catalog: Object.freeze({ categories: Object.freeze((contract.catalog.categories || []).slice()), lineCount: contract.catalog.lines.length }),
    commerce: Object.freeze(contract.commerce || {}),
    merchandising: Object.freeze(contract.merchandising || {}),
    design: Object.freeze({
      tokens: Object.freeze(contract.design.tokens || {}),
      motions: Object.freeze(contract.design.motions || {}),
      components: Object.freeze(contract.design.components || {}),
      primitives: Object.freeze(contract.design.primitives || {}),
      assets: Object.freeze(contract.design.assets || {}),
      behaviors: Object.freeze(contract.design.behaviors || {}),
    }),
    list: list,
    resolve: resolve,
    cartItem: cartItem,
    applyDesignTokens: applyDesignTokens,
    mountMotions: mountMotions,
    mountPromotions: mountPromotions,
    mountStickyStates: mountStickyStates,
    setMappedAsset: setMappedAsset,
    symbolAsset: symbolAsset,
    rankMerchandise: rankMerchandise,
    mountMerchandising: mountMerchandising,
  });

  function boot(event) {
    mountChrome();
    var scope = event && event.target ? event.target : document;
    mountPromotions(scope);
    mountMerchandising(scope);
    mountStickyStates(scope);
    mountMotions(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
